<ion-header>
  <ion-toolbar>
    <ion-title>Änderungshistorie – {{ orderNumber || orderId }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">

  <!-- Loading -->
  <div *ngIf="loading" class="loading-container">
    <ion-spinner name="crescent"></ion-spinner>
    <p>Lade Historie...</p>
  </div>

  <!-- Versions List -->
  <ng-container *ngIf="!loading">

    <div class="summary-info" *ngIf="versions.length > 0">
      <ion-icon name="git-commit-outline"></ion-icon>
      {{ versions.length }} {{ versions.length === 1 ? 'Eintrag' : 'Einträge' }}
    </div>

    <div *ngIf="versions.length === 0" class="empty-state">
      Keine Änderungen vorhanden.
    </div>

    <div *ngIf="versions.length > 0" class="toolbar-row">
      <ion-checkbox [checked]="allSelected" (ionChange)="toggleSelectAll()"></ion-checkbox>
      <span>Alle auswählen</span>
      <ion-button size="small" fill="outline" [disabled]="selectedVersions.length === 0" (click)="downloadSelected()">
        <ion-icon name="download-outline" slot="start"></ion-icon>
        Auswahl als JSON ({{ selectedVersions.length }})
      </ion-button>
    </div>

    <ion-list *ngIf="versions.length > 0">
      <ion-item *ngFor="let version of versions; trackBy: trackByVersionId" lines="full">
        <ion-checkbox slot="start" [(ngModel)]="version.selected"></ion-checkbox>
        <ion-label>
          <div class="version-row">
            <span class="version-badge" [class.badge-yellow]="version.color === 'yellow'" [class.badge-blue]="version.color === 'blue'">
              {{ version.colorLabel }}
            </span>
            <div class="version-date">
              {{ version.updatedAt | date:'dd.MM.yy HH:mm:ss' }}
            </div>
          </div>
          <div class="version-user">
            {{ version.updatedBy }}
          </div>
          <div class="version-actions">
            <ion-button size="small" fill="clear" (click)="downloadVersion(version)">
              <ion-icon name="download-outline" slot="start"></ion-icon>
              JSON
            </ion-button>
            <ion-button size="small" fill="clear" (click)="restoreAsNewOrder(version)">
              <ion-icon name="duplicate-outline" slot="start"></ion-icon>
              Als neuen Auftrag wiederherstellen
            </ion-button>
          </div>
        </ion-label>
      </ion-item>
    </ion-list>

  </ng-container>

</ion-content>
